import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { LogistikProductAvailability } from '@chancenwerk/db/enums/LogistikEnums.js';
import { colors } from '@chancenwerk/design/theme.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement logistik-component-product-availability
 */
@customElement('logistik-component-product-availability')
export class LogistikComponentProductAvailability extends ChemistryLitElement {
  @property({ type: LogistikComponentProductAvailability, reflect: true }) status = null;
  override render() {
    return html`
      <cr-flex>
        <cr-text ${css({ fontSize: '0.8rem', color: this._getStatusColor(this.status) })}
          >${this.status !== '' ? this.status : 'unbekannt'}</cr-text
        >
      </cr-flex>
    `;
  }

  private _getStatusColor(status: LogistikProductAvailability | null) {
    switch (status) {
      case LogistikProductAvailability.AVAILABLE:
        return colors.darkgreen;
      case LogistikProductAvailability.UNAVAILABLE:
        return colors.red;
      default:
        return '#777';
    }
  }
}
